// src/hooks/useAdminAccess.js
import { useAuth } from '../context/AuthContext';

export function useAdminAccess() {
  const { user, permissions } = useAuth();
  
  // First check permissions object from auth context
  if (permissions) {
    return {
      isAdmin: permissions.isAdmin || permissions.isDomainAdmin,
      isDomainAdmin: permissions.isDomainAdmin,
      isSuperAdmin: permissions.isAdmin,
      canManageUsers: permissions.canManageUsers
    };
  }
  
  // Fallback to role-based checks if permissions aren't available
  return {
    isAdmin: user?.role === 'admin' || user?.is_domain_admin,
    isDomainAdmin: user?.is_domain_admin,
    isSuperAdmin: user?.role === 'admin',
    canManageUsers: user?.role === 'admin' || user?.is_domain_admin
  };
}